export default {
	"ASCII": false,
	"Alphabetic": false,
	"Any": false,
	"Default_Ignorable_Code_Point": false,
	"Lowercase": false,
	"Noncharacter_Code_Point": false,
	"Uppercase": false,
	"White_Space": false
};

export const NAME_ALIAS = {};